import React from 'react';
import {
  Grid,
  IconButton,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  TextField,
  InputAdornment,
  Typography,
  CircularProgress
} from '@material-ui/core'
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import {
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Favorite as FavoriteIcon,
  MonetizationOn as MonetizationOnIcon,
  MoneyOff as MoneyOffIcon,
} from '@material-ui/icons'

import { Helmet } from 'react-helmet';

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import Commify from 'comma-number';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import APIServer from '../../config/server.conf.json';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

function setCurrencyData(data) {
  // USE
  var default_use = [
    'KRW', 'USD', 'EUR', 'GBP', 'JPY', 'CNY'
  ];

  var saved_use_list = default_use;

  for(let i=0;i<data.length;i++) {
    data[i].use = saved_use_list.indexOf(data[i].code) !== -1;
  }

  return data;
}

export default class Fxi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      base_currency: 'KRW',
      currency: [],
      isLoading: true,
    }
  }

  componentDidMount() {
    fetch(`${APIServer.baseUrl}/api/v1/fxi/get`)
      .then(res => res.json())
      .then(res => {
        let currency = setCurrencyData(res.data.rows);

        this.setState({
          ...this.state,
          date: res.data.date,
          currency: currency,
          isLoading: false,
        });
      })
  }

  handleUseCurrency = (row, set) => {
    if(row.code !== 'KRW') {
      this.setState({
        currency: this.state.currency.map((e, i) => {
          if(e.code === row.code) {
            return {
              ...row,
              use: set,
              numberFormat: (set && this.state.base_currency && this.state.base_currency.numberFormat ? ((this.state.base_currency.value * parseFloat(this.state.base_currency.numberFormat)) / e.value).toFixed(2).toString():'0.00'),
              calc_value: (set && this.state.base_currency && this.state.base_currency.numberFormat ? ((this.state.base_currency.value * parseFloat(this.state.base_currency.numberFormat)) / e.value).toFixed(2):0.00)
            }
          }
          
          return e;
        })
      });
    }
  }

  handleChangeCurrency = (row) => event => {
    this.setState({
      base_currency: row
    });
  }

  handleChange = (row) => event => {
    if(row.code === this.state.base_currency.code) {
      // Set Basecurrency
      this.setState({
        base_currency: {
          ...row,
          numberFormat: event.target.value,
          calc_value: parseFloat(event.target.value).toFixed(2)
        }
      });

      let changed_value = this.state.currency.map((e, i) => {
        if(e.code === this.state.base_currency.code) {
          return {
            ...row,
            numberFormat: event.target.value,
            calc_value: parseFloat(event.target.value).toFixed(2)
          }
        } else if(e.use) {
          return {
            ...e,
            numberFormat: (event.target.value ? ((this.state.base_currency.value * parseFloat(event.target.value)) / e.value).toFixed(2).toString():'0.00'),
            calc_value: (event.target.value ? ((this.state.base_currency.value * parseFloat(event.target.value)) / e.value).toFixed(2):0.00)
          }
        }
        
        return e;
      });

      this.setState({
        currency: changed_value
      });
    }
  }

  render() {
    return (
      <Grid container direction="column">
        <Helmet
          title="환율 계산기"
          meta={[
            { "name": "description", "content": "환율 계산기" },
            { "name": "keywords", "content": "toolbox, tbx, 툴박스, exchanges, exchanges calculator, 환율, 환율계산기, 환율 계산기" },
            { property: "og:title", content: "환율 계산기 - TBX" },
            { property: "og:description", content: "환율 계산기 - TBX" },
            { property: "og:title", content: "환율 계산기 - TBX" },
          ]}
        />
        <Grid item xs={12}>
          <ReactResizeDetector handleWidth handleHeight>
            {({ width, height }) => <CoupangPartners width={width} height={height} />}
          </ReactResizeDetector>
        </Grid>
        <Grid item xs={12} xl={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <Card>
                <CardHeader color="warning">
                  <Typography variant="h6"><MonetizationOnIcon style={{ verticalAlign: 'sub' }} /> 환율 계산</Typography>
                </CardHeader>
                {this.state.isLoading &&
                <CardBody style={{ alignSelf: 'center', padding: 50 }}>
                  <CircularProgress color="secondary" size={50} />
                </CardBody>
                }
                {!this.state.isLoading &&
                <CardBody>
                  <Typography variant="subtitle2" align="right">
                    기준일: {this.state.date}
                  </Typography>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>통화</TableCell>
                        <TableCell>기준가</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.currency.filter((e) => { return e.use }).map((row, idx) => (
                        <TableRow key={row.code}>
                          <TableCell component='th' scope='row'>
                            {row.code === 'KRW' && <IconButton size='small' style={{ color: '#e91e63' }}>
                              <FavoriteIcon fontSize='small' />
                            </IconButton>
                            }
                            {row.code !== 'KRW' && <IconButton size='small' style={{ color: 'orange' }} onClick={() => { this.handleUseCurrency(row, false)}}>
                              <StarIcon fontSize='small' />
                            </IconButton>
                            }
                          </TableCell>
                          <TableCell component='th' scope='row'>
                            {row.name}
                          </TableCell>
                          <TableCell component='th' scope='row'>
                            {row.code !== 'KRW' &&
                            <span>
                              {Commify(row.value * row.original_unit)}원 {row.original_unit > 1 ? `(${row.mark}${Commify(row.original_unit)})`:''}
                            </span>}
                          </TableCell>
                          <TableCell component='th' scope='row'>
                            <TextField
                              value={row.numberFormat}
                              onFocus={this.handleChangeCurrency(row)}
                              onChange={this.handleChange(row)}
                              InputProps={{
                                inputComponent: NumberFormatCustom,
                                startAdornment: <InputAdornment position='start'>{row.mark}</InputAdornment>,
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardBody>
                }
              </Card>
            </Grid>
            <Grid item xs={12} lg={4}>
              <Card>
                <CardHeader color="success">
                  <Typography variant="h6"><MoneyOffIcon style={{ verticalAlign: 'sub' }} /> 통화 목록</Typography>
                </CardHeader>
                {this.state.isLoading &&
                <CardBody style={{ alignSelf: 'center', padding: 50 }}>
                  <CircularProgress color="secondary" size={50} />
                </CardBody>
                }
                {!this.state.isLoading &&
                <CardBody>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>통화</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.currency.filter((e) => { return !e.use }).length === 0 && <TableRow>
                        <TableCell></TableCell>
                        <TableCell colSpan={2}>
                          남은게 없음...
                        </TableCell>
                      </TableRow>
                      }
                      {this.state.currency.filter((e) => { return !e.use }).map(row => (
                        <TableRow key={row.code}>
                          <TableCell component='th' scope='row'>
                            <IconButton size='small' onClick={() => { this.handleUseCurrency(row, true)}}>
                              <StarBorderIcon fontSize='small' />
                            </IconButton>
                          </TableCell>
                          <TableCell component='th' scope='row'>
                            {row.name}
                          </TableCell>
                          <TableCell component='th' scope='row'>
                            {row.mark}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardBody>
                }
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}